export { Trash as default } from './Trash';
